/* eslint-disable no-unused-vars */
export enum Duration {
  Second = 1000,
  Minute = 1000 * 60,
  Hour = 1000 * 60 * 60,
  Day = 1000 * 60 * 60 * 24,
}

export enum FlagCountryFromLanguage {
  CS = 'CZ',
  EN = 'GB',
  DE = 'DE',
  IT = 'IT',
  FR = 'FR',
  SV = 'SE',
  DA = 'DK',
  NB = 'NO',
  FI = 'FI',
  ES = 'ES',
  PT = 'PT',
  BG = 'BG',
  HR = 'HR',
  PL = 'PL',
  SI = 'SI',
  NL = 'NL',
}
